import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  inject,
  input,
  OnInit,
  output,
} from '@angular/core';
import { QarepaBaseSubsDirective } from '@qarepa/common';
import { TicketFileCustom } from '@qaroni-app/ticket/types/ticket-files-custom';
import { TempFilesService } from '@qaroni-core/services/app/temp-files/temp-files.service';
import { TempFiles } from '@qaroni-core/types/files/temp-files';
import { FileValidations } from '@qaroni-core/utils/validations/file-validation';

@Component({
  selector: 'qaroni-upload-files-item',
  templateUrl: './upload-files-item.component.html',
  styleUrl: './upload-files-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UploadFilesItemComponent
  extends QarepaBaseSubsDirective
  implements OnInit
{
  readonly file = input<TicketFileCustom | null>(null);
  readonly uploadedFile = output<void>();
  readonly deleteFile = output<number>();

  private tempFilesService = inject(TempFilesService);
  private _cdr = inject(ChangeDetectorRef);

  public progressBarMode: 'indeterminate' | 'determinate' = 'indeterminate';
  public uploadComplete = false;

  private tempFile$ = this.tempFilesService.getUploadFileSubject$();

  constructor() {
    super();

    effect(this.fileCustomEffect);
  }

  ngOnInit(): void {
    this.subs.add(this.tempFile$.subscribe(this.getUploadedFile));
  }

  public onDeleteFile(): void {
    const file = this.file();
    if (file) {
      file.uploadedFile = null;
      this.deleteFile.emit(file.index);
    }
  }

  private fileCustomEffect = () => {
    const fileCustom = this.file();
    if (fileCustom?.file) {
      this.uploadFiles();
    }
  };

  private getUploadedFile = (file: TempFiles | null): void => {
    if (!file) {
      return;
    }

    const fileCustom = this.file();
    const fileName = this.normalizeFileName(fileCustom?.name);
    const uploadedFileName = this.normalizeFileName(file.originalName);

    if (fileName === uploadedFileName) {
      this.uploadComplete = true;
      this.progressBarMode = 'determinate';
      if (fileCustom) {
        fileCustom.progress = 100;
        fileCustom.uploadedFile = file;
      }
      this.uploadedFile.emit();
    }
    this._cdr.markForCheck();
  };

  private uploadFiles(): void {
    const fileCustom = this.file();
    if (!fileCustom?.file) {
      return;
    }

    let dataMultipart = new FormData();
    dataMultipart = FileValidations.buildMultipartFiles(dataMultipart, 'file', [
      fileCustom.file,
    ]);

    this.tempFilesService.uploadTempFile(dataMultipart);
  }

  private normalizeFileName(fileName: string): string {
    return (fileName ?? '').replace(/\s+/g, '').toLocaleLowerCase();
  }
}
